module.exports = __webpack_public_path__ + "static/media/menu_logo.e55e3fcd.png";